import { StyledStack } from './Stack.styles';

export default StyledStack;
